var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
export class Router {
    constructor(mainTag) {
        this.routes = {};
        this.initRouter = (routes) => {
            this.routes = routes;
            window.addEventListener('popstate', () => {
                this.handleLocation();
            });
            this.handleLocation();
        };
        this.route = (event, func) => {
            event = event || window.event;
            event.preventDefault();
            const target = event.target;
            const link = target === null || target === void 0 ? void 0 : target.closest('a');
            if (link) {
                window.history.pushState({}, '', link.href);
            }
            if (func) {
                this.handleLocation().then(func);
            }
            else {
                this.handleLocation();
            }
        };
        this.handleLocation = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            let path = window.location.pathname;
            let route = this.routes[path];
            const [rootPath, id = null] = path.split('/').filter((item) => !!item);
            if (!Object.prototype.hasOwnProperty.call(this.routes, path) &&
                !this.routes[`/${rootPath}/:id`]) {
                path = '404';
            }
            if (this.routes[`/${rootPath}/:id`]) {
                route = this.routes[`/${rootPath}/:id`];
                path = `/${rootPath}/:id`;
            }
            this.routes[this.activeRoute].unmount();
            if ((_a = route === null || route === void 0 ? void 0 : route.mountedProps) === null || _a === void 0 ? void 0 : _a.mounted) {
                const props = {
                    mounted: route.mountedProps.mounted
                };
                if (id) {
                    props.params = {
                        productId: +id
                    };
                }
                route.mount(props);
            }
            else {
                route = this.routes[path];
                route.mount();
            }
            this.activeRoute = path;
        });
        this._mainTag = mainTag;
        this.activeRoute = '/';
    }
}
